import axios from "axios";
import { RUTA_SERVIDOR_BACKEND } from "./configuraciones";

import store from "../store";

export const getPreliminariesLiquidations = async () => {

  let dataAux = [];

  await axios.get(`${RUTA_SERVIDOR_BACKEND}/liquidations/indexPreliminariesLiquidations`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {

    dataAux = data;

  });

  return dataAux;

};

export const filterPreliminariesLiquidations = async (data) => {

  let dataAux = [];

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/liquidations/indexPreliminariesLiquidations`,
    {
      filters: data
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {

    dataAux = data;

  });

  return dataAux;

};

export const createOrUpdatePreliminaryLiquidation = async (data) => {

  let dataAux = [];

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/liquidations/createOrUpdatePreliminaryLiquidation`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {

    dataAux = data;

  });

  return dataAux;

};

export const deletePreliminaryLiquidation = async (data) => {

  let dataAux = [];

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/liquidations/deletePreliminaryLiquidation`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {

    dataAux = data;

  });

  return dataAux;

};

//finals

export const getFinalsLiquidations = async () => {

  let dataAux = [];

  await axios.get(`${RUTA_SERVIDOR_BACKEND}/liquidations/indexFinalsLiquidations`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {

    dataAux = data;

  });

  return dataAux;

};

export const filterFinalsLiquidations = async (data) => {

  let dataAux = [];

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/liquidations/indexFinalsLiquidations`,
    {
      filters: data
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {

    dataAux = data;

  });

  return dataAux;

};

export const createFinalLiquidation = async (data) => {

  let dataAux = [];

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/liquidations/createFinalLiquidation`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {

    dataAux = data;

  });

  return dataAux;

};

export const getDetailsByBooking = async (data) => {

  let dataAux = [];

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/liquidations/getDetailsByBooking`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {

    dataAux = data;

  });

  return dataAux;

};

export const removeBookingFromLiquidation = async (data) => {

  let dataAux = [];

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/liquidations/removeBookingFromLiquidation`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {

    dataAux = data;

  });

  return dataAux;

};

export const confirmFinalLiquidation = async (data) => {

  let dataAux = [];

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/liquidations/confirmFinalLiquidation`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {

    dataAux = data;

  });

  return dataAux;

};

export const cancelFinalLiquidation = async (data) => {

  let dataAux = [];

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/liquidations/cancelFinalLiquidation`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {

    dataAux = data;

  });

  return dataAux;

};

export const sendFinalLiquidation = async (data) => {

  let dataAux = [];

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/liquidations/sendFinalLiquidation`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {

    dataAux = data;

  });

  return dataAux;

};

//generales

export const getPreviewLiquidation = async (data) => {

  let dataAux = [];

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/liquidations/liquidationPreview`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {

    dataAux = data;

  });

  return dataAux;

};

export const regenerateLiquidation = async (data) => {

  let dataAux = [];

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/liquidations/regenerateLiquidation`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {

    dataAux = data;

  });

  return dataAux;

};

export const getCustomerEmails = async (data) => {

  let dataAux = [];

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/liquidations/getCustomerEmails`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {

    dataAux = data;

  });

  return dataAux;

};

export const getExtraCostType = async (data) => {

  let dataAux = [];

  store.state.liquidations.loadingExtraCostos = true;

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/extra-costs-liquidations/getExtraCostsFiltered`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {

    dataAux = data;

  });

  store.state.liquidations.loadingExtraCostos = false;

  return dataAux;

};

//importador

export const getImportedLiquidationsContainers = async (data) => {

  let dataAux = [];

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/liquidations/getImportedLiquidationsContainers`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {

    dataAux = data;

  });

  return dataAux;

};

export const createOrUpdateContainers = async (data) => {

  let dataAux = [];

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/liquidations/createOrUpdateContainer`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {

    dataAux = data;

  });

  return dataAux;
};

export const importLiquidationsContainers = async (file) => {

  let dataAux = [];

  let dataForm = new FormData();

  dataForm.append("containers_file", file);

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/liquidations/importLiquidationsContainers`, dataForm, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  }).then(({ data }) => {

    dataAux = data;

  });

  return dataAux;

};

//glosas

export const getGlosses = async (data) => {

  let dataAux = [];

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/liquidations/getGlosses`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {

    dataAux = data;

  });

  return dataAux;

};

export const getLiquidationsInvoiceLists = async () => {

  let dataAux = [];

  await axios.get(`${RUTA_SERVIDOR_BACKEND}/liquidations/getInvoiceLists`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {

    dataAux = data;

  });

  return dataAux;

};

export const createOrUpdateGlosses = async (data) => {

  let dataAux = [];

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/liquidations/createOrUpdateGlosses`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {

    dataAux = data;

  });

  return dataAux;
};

export const deleteGlosses = async (data) => {

  let dataAux = [];

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/liquidations/deleteGlosses`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(({ data }) => {

    dataAux = data;

  });

  return dataAux;

};

